/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Box, Grid } from '@mui/material';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import AssetLocationCreation from '../views/assetLocationCreation';
import AssetLocationUserList from '../views/assetLocationUserList';

const ManageAssetLocationPage = () => {
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Asset Location Users'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6}>
                        <AssetLocationCreation />
                    </Grid>
                </Grid>

                <AssetLocationUserList />
            </Box >

        </>
    )
}

export default ManageAssetLocationPage;